import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BaseIcon } from '../BaseIcon';
export const CheckboxDisabled = ({ height = '16px', stroke, width = '16px', ...rest }) => {
    const { color } = useTheme();
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: '0 0 16 16', ...rest, children: _jsx("path", { d: 'M14 2 2 14', stroke: stroke || color.stroke.disabled.text.on.background }) }));
};
//# sourceMappingURL=CheckboxDisabled.js.map